import { logError } from "../../../../utils/analytics";

export const groupChatsByDate = (chats) => {
  const groups = {};

  chats.forEach(chat => {
    let dateKey = 'No messages yet';

    if (chat.lastMessageTimestamp) {
      try {
        const timestamp = chat.lastMessageTimestamp;
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

        if (!isNaN(date.getTime())) {
          const today = new Date();
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);

          today.setHours(0, 0, 0, 0);
          yesterday.setHours(0, 0, 0, 0);
          const compareDate = new Date(date);
          compareDate.setHours(0, 0, 0, 0);

          if (compareDate.getTime() === today.getTime()) {
            dateKey = 'Today';
          } else if (compareDate.getTime() === yesterday.getTime()) {
            dateKey = 'Yesterday';
          } else {
            dateKey = date.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              timeZone: 'UTC'
            });
          }
        }
      } catch (error) {
        logError('groupChatsByDate: format date', error);
      }
    }

    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(chat);
  });

  const sortedGroups = {};
  const groupOrder = ['Today', 'Yesterday'];

  groupOrder.forEach(key => {
    if (groups[key]) {
      sortedGroups[key] = groups[key];
    }
  });

  Object.keys(groups)
    .filter(key => !groupOrder.includes(key) && key !== 'No messages yet')
    .sort((a, b) => {
      try {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateB - dateA;
      } catch (error) {
        return 0;
      }
    })
    .forEach(key => {
      sortedGroups[key] = groups[key];
    });

  if (groups['No messages yet']) {
    sortedGroups['No messages yet'] = groups['No messages yet'];
  }

  return sortedGroups;
};

export const getChatIcon = (tag) => {
  switch (tag) {
    case "Spam":
      return "pi pi-trash";
    case "Sold":
      return "pi pi-money-bill";
    case "Interested":
      return "pi pi-star";
    case "Chatting":
      return "pi pi-comments";
    case "Block":
      return "pi pi-times";
    default:
      return "pi pi-comments";
  }
}; 